import { render } from "./CompanyIntroduction.vue?vue&type=template&id=08da34fb"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__